import AllRequestsSVG from "../../../SharedComponents/assets/icons/svg/AllRequestsSVG";
import BellIconSVG from "../../../SharedComponents/assets/icons/svg/BellIconSVG";
import HelpIconSVG from "../../../SharedComponents/assets/icons/svg/HelpIconSVG";
import HomeIconSVG from "../../../SharedComponents/assets/icons/svg/HomeIconSVG";
import MessagesIconSVG from "../../../SharedComponents/assets/icons/svg/MessagesIconSVG";
import MessagesLetterIconSVG from "../../../SharedComponents/assets/icons/svg/MessagesLetterIconSVG";
import SecurityIconSVG from "../../../SharedComponents/assets/icons/svg/SecurityIconSVG";
import CircledImage from "../../../SharedComponents/components/ImageComponents/CircledImage";
import OffersIconSVG from "../../assets/icons/svg/OffersIconSVG.js";
import AssortmentIconSVG from "../../assets/icons/svg/AssortmentIconSVG.js";
import TransactionsIconSVG from "../../assets/icons/svg/TransactionsIconSVG.js";
import CreditsIconSVG from "../../assets/icons/svg/CreditsIconSVG.js";


//TODO - Define the routes and implement routing to the target page
export const sellerSidebarLinksData = [
    {
        icon: (color) => HomeIconSVG(color),
        name: 'Početak',
        href: "/home"
    },
    {
        icon: (color) => AllRequestsSVG(color),
        name: "Zahtevi",
        href: "/request",
    },
    {
        icon: OffersIconSVG,
        name: "Ponude",
        href: "/offers"
    },
    {
        icon: AssortmentIconSVG,
        name: "Asortiman",
        href: "/store"
    },
    {
        icon: TransactionsIconSVG,
        name: "Transakcije",
        href: "/transactions"
    },
    {
        icon: CreditsIconSVG,
        name: "Krediti",
        href: "/credits"
    },
    {
        icon: MessagesIconSVG,
        name: "Poruke",
        href: "/messages",
    },
    {
        icon: BellIconSVG,
        name: "Obaveštenja",
        href: "/notifications",
    },
];


export const sellerBottomSidebarLinksData = [
    {
        icon: HelpIconSVG,
        name: "Pomoć",
        href: "/support"
    }
]